import {combineReducers} from 'redux'

import {menuReducer} from './menuReducer'
import {slideReducer} from './slideReducer'
import {viewsReducer} from './viewsReducer'

const combinedReducer = combineReducers({
    slideReducer,
    menuReducer,
    viewsReducer
})

export default combinedReducer